import { ConditionTypeRegistry } from "common/form/fields/condition/ConditionTypeRegistry";
import initialState from "core/reducers/initialState";

export default class PanelUtil {

	public static getEditName(config: any): string {
		return config && config['__editName'] || config['editName'];
	}

	public static showBorder(config: any): boolean {
		return (config && config['__border']) === true;
	}

	public static getTitle(config: any): string {
		return config && config['__title'];
	}

	public static isAccessible(config: object, state: typeof initialState) {
		if (config['__permissions'] && config['__permissions'].type) {
			return ConditionTypeRegistry.evaluate(config['__permissions'], state);
		}
		return true;
	}
}



// WEBPACK FOOTER //
// ./src/core/util/PanelUtil.ts